/**
 * @file sku-restore-errors.ts
 * @description Человеческие тексты отказов восстановления фасовки (phase19.13).
 *
 * Реестром, а не каскадом if: новый код сервера = новая строка. Незнакомый код
 * показываем сообщением сервера — оно уже на русском.
 */

import { ApiError } from "../../../lib/api-client";

const RESTORE_ERROR_TEXT: Record<string, string> = {
  sku_not_archived: "Фасовка не в архиве — восстанавливать нечего",
  sku_product_archived: "Товар в архиве — сначала восстановите товар",
};

/** Текст тоста по ошибке восстановления фасовки. */
export function skuRestoreErrorText(err: unknown): string {
  if (!(err instanceof ApiError)) return "Не удалось восстановить фасовку";
  return RESTORE_ERROR_TEXT[err.code] ?? err.message;
}
